import { AlertTriangle } from "lucide-react";
import { useCountUp } from "@/lib/useCountUp";
import { euro } from "@/lib/format";

const Amount = ({ value, testId, className = "" }) => {
  const v = useCountUp(value);
  return (
    <span className={`font-mono font-semibold tracking-[-0.03em] ${className}`} data-testid={testId} data-value={Math.round(value)}>
      {euro(v)}
    </span>
  );
};

const ResultCard = ({ tone, label, value, testId, children }) => (
  <div className={`rounded-2xl p-6 sm:p-7 ${tone === "red" ? "glass-red" : "glass-cyan"}`} data-testid={`${testId}-card`}>
    <p className={`text-[11px] font-semibold tracking-[0.2em] uppercase ${tone === "red" ? "text-[#ff6b76]" : "text-cyan"}`}>{label}</p>
    <Amount value={value} testId={testId} className="mt-4 block text-3xl sm:text-4xl text-white" />
    {children}
  </div>
);

export const CalcResults = ({ agency, prodigy, plan, over, suggestion, onSuggest }) => {
  const diff = agency - prodigy;
  return (
    <div>
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
        <ResultCard tone="red" label="Costo Medio Agenzie" value={agency} testId="calc-agency">
          <p className="mt-3 font-mono text-xs text-titanium">RAL × 15% × assunzioni</p>
        </ResultCard>
        <ResultCard tone="cyan" label="Costo Fisso Prodigy" value={prodigy} testId="calc-prodigy">
          <p className="mt-3 font-mono text-xs text-titanium" data-testid="calc-contacts">
            Piano {plan.name}: {plan.contactsLabel}
          </p>
        </ResultCard>
      </div>
      <div className="mt-6 rounded-2xl border border-[#1e2024] bg-black/40 px-6 py-5 flex flex-wrap items-baseline justify-between gap-3" data-testid="calc-savings-row">
        <span className="text-sm sm:text-base text-titanium" data-testid="calc-savings-label">
          {diff >= 0 ? "Risparmio netto stimato:" : "Costo aggiuntivo stimato:"}
        </span>
        <Amount value={Math.abs(diff)} testId="calc-savings" className={`text-3xl sm:text-4xl ${diff >= 0 ? "text-cyan calc-glow" : "text-white/80"}`} />
      </div>
      {over && (
        <div className="mt-4 rounded-2xl border border-[#ffb020]/40 bg-[#ffb020]/[0.06] px-5 py-4 flex flex-wrap items-center justify-between gap-3" data-testid="calc-warning">
          <p className="flex items-start gap-3 text-sm text-white/90">
            <AlertTriangle className="mt-0.5 h-4 w-4 shrink-0 text-[#ffb020]" />
            Le assunzioni stimate superano i contatti inclusi nel piano selezionato.
          </p>
          {suggestion && (
            <button type="button" onClick={() => onSuggest(suggestion.id)} className="cta cta-glow glass min-h-[44px] rounded-full px-5 py-2.5 text-sm font-semibold text-white" data-testid="calc-suggest-btn">
              Passa a {suggestion.name}
            </button>
          )}
        </div>
      )}
    </div>
  );
};
